<template>
  <SamSidebar
    :is-open="Boolean(component)"
    v-bind="sidebarProps"
    @close="handleClose"
  >
    <component
      :is="component"
      v-if="Boolean(component)"
      v-bind="props"
      @close="handleClose"
    />
  </SamSidebar>
</template>

<script>
import SAMORA_EVENTS from '../../../utils/events';
import EventBus from '../../../utils/eventBus';
import SamSidebar from '../SamSidebar/SamSidebar.vue';

export default {
  name: 'SamSidebarManager',
  components: {
    SamSidebar,
  },
  data() {
    return {
      component: null,
      sidebarProps: null,
      props: null,
    };
  },
  created() {
    EventBus.on(SAMORA_EVENTS.OPEN_SIDEBAR, this.handleOpen);
    EventBus.on(SAMORA_EVENTS.CLOSE_SIDEBAR, this.handleClose);
  },
  methods: {
    handleOpen({ component, sidebarProps = null, props = null }) {
      this.component = component;
      this.sidebarProps = sidebarProps;
      this.props = props;
    },
    handleClose() {
      this.component = null;
      this.sidebarProps = null;
      this.props = null;
    },
  },
};
</script>
